export const profile = [
  {
    value: 'profile',
    icon: 'fa-user',
    route: {
      name: 'editProfile',
    },
  },
  {
    value: 'password',
    icon: 'fa-lock',
    route: {
      name: 'editPassword',
    },
  },
];

export const systemSettings = [
  {
    value: 'medicalCondition',
    icon: 'fa-heart',
    route: {
      name: 'medicalConditions',
    },
  },
  {
    value: 'scalpCondition',
    icon: 'fa-cut',
    route: {
      name: 'scalpConditions',
    },
  },
  {
    value: 'mediaTag',
    icon: 'fa-images',
    route: {
      name: 'mediaTags',
    },
  },
];

export const userNew = [
  {
    value: 'profile',
    icon: 'fa-user',
    route: {
      name: 'createUser',
    },
  },
];

export const user = [
  {
    value: 'media',
    icon: 'fa-images',
    route: {
      name: 'editUserMedia',
      key: 'id',
    },
  },
  {
    value: 'profile',
    icon: 'fa-user',
    route: {
      name: 'editUser',
      key: 'id',
    },
  },
  {
    value: 'points',
    icon: 'fa-coins',
    permission: ['admin', 'superadmin'],
    route: {
      name: 'userPoints',
      key: 'id',
    },
  },
  {
    value: 'password',
    icon: 'fa-lock',
    permission: ['superadmin'],
    route: {
      name: 'editUserPassword',
    },
  },
];
